import React, { useState } from 'react';
import { templateTagActions, privateTemplateTagAPI } from '../../../../../entities/template/private-template-tag';
import { useAppDispatch } from '../../../../../shared/libs/redux';
import { templateTagGroupApi } from '../../../../../entities/template/private-template-tag-group';
import {
	notificationError, notificationSuccess, notificationWarning,
} from '../../../../../components/Notifications/callNotifcation';
import { ITag } from '../../../../../entities/module/private-template-module-tag/api/types';

export const useEditableTag = (initialName: string, tag: ITag) => {
	const dispatch = useAppDispatch();

	const [editableTag, setEditableTag] = useState<number | null>(null);
	const [newTagName, setNewTagName] = useState(initialName);

	const { data: existingGroups } = privateTemplateTagAPI.useGetAllQuery({ limit: 127, page: 1 });
	const [updateTag] = privateTemplateTagAPI.useUpdateMutation();

	const onDeletingTag = () => {
		dispatch(templateTagActions.setDeletingTagId(tag.id));
		dispatch(templateTagActions.setIsDeletingTagModalActive(true));
	};

	const updateTagName = async () => {
		try {
			if (newTagName.trim().length < 2) {
				notificationError('Ошибка', 'Тег должен содержать не менее 2-х символов');
				return;
			}

			if (newTagName === initialName) {
				setEditableTag(null);
				return;
			}

			const tagNames = existingGroups?.templateTags.map((tag) => tag.name.toLowerCase()) ?? [];
			if (tagNames.includes(newTagName.toLowerCase())) {
				notificationWarning(
					'Изменение названия тега',
					`Тег с именем "${newTagName}" уже существует`,
				);
				return;
			}

			if (editableTag !== null && newTagName.trim() !== '') {
				await updateTag({
					templateTags: [{
						id: editableTag,
						name: newTagName,
						sequenceNumber: tag.sequenceNumber,
					}],
				})
					.unwrap();

				setEditableTag(null);
				dispatch(templateTagGroupApi.util?.invalidateTags(['templateTagGroup']));
				dispatch(privateTemplateTagAPI.util?.invalidateTags(['template_tags']));
				notificationSuccess('Название тега изменено успешно');
			}
		} catch (e) {
			notificationError('Произошла ошибка при обновлении имени тега...');
			console.log(e);
		}
	};

	const handleTagNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNewTagName(e.target.value);
	};

	return {
		editableTag,
		setEditableTag,
		setNewTagName,
		newTagName,
		handleTagNameChange,
		updateTagName,
		onDeletingTag,
	};
};
